import script from "./CollectivitesRecouvrement.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectivitesRecouvrement.vue?vue&type=script&setup=true&lang=ts"

import "./CollectivitesRecouvrement.vue?vue&type=style&index=0&id=7a0c2be8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a0c2be8"]])

export default __exports__